import axios, { AxiosResponse } from 'axios'
import { API_END_POINT_URL } from 'src/utils/constants'
import type { Response } from '@src/interface/api/response.interface'

const client = axios.create({
	withCredentials: true,
})

client.defaults.baseURL = `${API_END_POINT_URL}/`

export default client
